/**
 * Provider Selector Component
 * Dropdown to select cloud provider
 */

import React from "react";
import { useProvider } from "../../hooks/useProvider";
import "../../styles/global.css";

const ProviderSelector = ({ className = "", showLabel = true }) => {
  const { selectedProvider, setSelectedProvider, availableProviders, loading } =
    useProvider();

  const handleChange = (e) => {
    setSelectedProvider(e.target.value);
  };

  if (loading) {
    return (
      <div className={`provider-selector ${className}`}>
        {showLabel && <label>Provider</label>}
        <select disabled className="provider-select">
          <option>Loading...</option>
        </select>
      </div>
    );
  }

  return (
    <div className={`provider-selector ${className}`}>
      {showLabel && (
        <label htmlFor="provider-select" className="provider-label">
          Provider
        </label>
      )}
      <select
        id="provider-select"
        value={selectedProvider}
        onChange={handleChange}
        className="provider-select"
      >
        {availableProviders.map((provider) => (
          <option key={provider.id} value={provider.id}>
            {provider.displayName || provider.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default ProviderSelector;
